import ConversationListCard from '@app/components/presentational/MessagingResponsive/ConversationListCard';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { IconButton, Icons, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';

const AllConversationView = (props) => {
  const {
    paginatedConversations,
    handleConversationClick,
    isAllConversationsDialogOpen,
    setIsAllConversationsDialogOpen,
  } = props;
  const { palette } = useTheme();

  return (
    <Dialog
      open={isAllConversationsDialogOpen}
      // onClose={() => setIsAllConversationsDialogOpen(false)}
      fullWidth
      maxWidth="xs"
      aria-labelledby="all-conversations-dialog-title"
      aria-describedby="all-conversations-dialog-description"
    >
      <DialogTitle id="all-conversations-dialog-title">
        All Conversations
        <IconButton
          onClick={() => setIsAllConversationsDialogOpen(false)}
          aria-label="Close"
          size="small"
          sx={{
            color: palette.text.secondary,
            '&:hover': { color: palette.text.primary },
            float: 'right',
          }}
        >
          <Icons.Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {paginatedConversations.length > 0 &&
          paginatedConversations.map((conversation) => (
            <ConversationListCard
              key={conversation?.id}
              conversation={conversation}
              selected={false}
              onClick={() => {
                handleConversationClick(conversation?.id);
              }}
            />
          ))}
      </DialogContent>
    </Dialog>
  );
};

export default AllConversationView;
